import React, { useState } from "react";
import {
    Table, TableHead, TableRow, TableCell, TableBody, Paper, Button, Typography,
    Box, Chip, Modal, TextField, IconButton, InputAdornment, CircularProgress, Tooltip
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import axios from "axios";
import baseURL from "../../config";
import { Edit as EditIcon, Search as SearchIcon } from "@mui/icons-material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransferVesselModal from "./TransferVesselModal";

const SignOnModal = ({ signonDetails }) => {
    const [open, setOpen] = useState(false);
    const [selectedContract, setSelectedContract] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [selectedContractId, setSelectedContractId] = useState(null);
    const [contractopenModal, setContractopenModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({
        portName: "",
        portCountry: "",
        date: "",
        cdcStamppageFile: "",
        passport: "",
        salaryclose: "",
    });

    const userID = localStorage.getItem("user id");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedCrewName, setSelectedCrewName] = useState("");


    const handleOpen = (contract, crewName) => {
        setSelectedContract(contract);
        setSelectedCrewName(crewName);
        setOpen(true);
        setFormData({
            portName: "",
            portCountry: "",
            date: "",
        });

    };

    const handleClose = () => {
        setOpen(false);
        setSelectedContract(null);
        setFormData({
            portName: "",
            portCountry: "",
            date: "",
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setFormData((prev) => ({
                ...prev,
                [name]: {
                    originalName: files[0].name,
                    file: files[0], // you can access this when uploading
                },
            }));
        }
    };

    const getContractRemainingDays = (startDateStr, durationInMonths) => {
        if (!startDateStr || !durationInMonths) return null;

        const startDate = new Date(startDateStr);
        const endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + parseInt(durationInMonths));

        const today = new Date();

        if (endDate <= today) return "Contract Ended";

        let remainingMonths = (endDate.getFullYear() - today.getFullYear()) * 12 +
            (endDate.getMonth() - today.getMonth());

        let adjustedEnd = new Date(today);
        adjustedEnd.setMonth(adjustedEnd.getMonth() + remainingMonths);

        // If adjustedEnd goes past the actual endDate, reduce a month
        if (adjustedEnd > endDate) {
            remainingMonths--;
            adjustedEnd.setMonth(adjustedEnd.getMonth() - 1);
        }

        // Now calculate the remaining days
        const remainingDays = Math.ceil((endDate - adjustedEnd) / (1000 * 60 * 60 * 24));

        const months = remainingMonths;
        const days = remainingDays;

        let result = [];
        if (months) result.push(`${months} month${months > 1 ? "s" : ""}`);
        if (days) result.push(`${days} day${days > 1 ? "s" : ""}`);

        return `Contract remaining : ${result.join(" ")} `;
    };

    const handleSave = async () => {
        const { portName, portCountry, date, cdcStamppageFile, passport, salaryclose } = formData;

        if (!portName || !portCountry || !date || !cdcStamppageFile || !passport || !salaryclose) {
            toast.error("All fields are required.");
            return;
        }

        if (!selectedContract) {
            alert("No contract selected!");
            return;
        }



        setLoading(true);

        const token = localStorage.getItem("token");

        const dataToSend = new FormData();

        // Append basic text data
        dataToSend.append("creatorId", userID);
        dataToSend.append("crewId", selectedContract.contractDetails?.crewDetails?._id || "");
        dataToSend.append("contractId", selectedContract.contractDetails?._id || "");

        // Prepare signOff metadata only (without files)
        const signOffData = [
            {
                date: formData.date,
                portName: formData.portName,
                portCountry: formData.portCountry,
            }
        ];
        dataToSend.append("signOff", JSON.stringify(signOffData));

        // Append files with nested keys
        if (formData.cdcStamppageFile?.file) {
            dataToSend.append("signOff[0][cdcStamppageFile]", formData.cdcStamppageFile.file);
        }

        if (formData.passport?.file) {
            dataToSend.append("signOff[0][passport]", formData.passport.file);
        }

        if (formData.salaryclose?.file) {
            dataToSend.append("signOff[0][salaryclose]", formData.salaryclose.file);
        }

        try {
            const response = await axios.post(`${baseURL}/api/statusAfterForm1`, dataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            toast.success("Data saved successfully!");
            handleClose();

            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error("Error saving data:", error.response?.data || error.message);
            alert("Failed to save data. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    const handleOpenSignOnFiles = (signOnData) => {
        const documents = [];

        if (signOnData.cdcStamppageFile?.filePath) {
            documents.push({
                name: "CDC Stamp Page",
                filePath: `${baseURL}/${signOnData.cdcStamppageFile.filePath.replace(/\\/g, "/")}`,
            });
        }

        if (signOnData.ImoCrewListFile?.filePath) {
            documents.push({
                name: "IMO Crew List",
                filePath: `${baseURL}/${signOnData.ImoCrewListFile.filePath.replace(/\\/g, "/")}`,
            });
        }

        setSelectedDocuments(documents);
        setOpenModal(true);
    };


    const handleTransfer = (contractId) => {
        setSelectedContractId(contractId);
        setContractopenModal(true);
    };

    // Search Filter Logic
    const filteredContracts = signonDetails?.filter(contract => {
        const vesselName = contract.contractDetails?.ShipDetails?.vesselname?.toLowerCase() || "";
        const crewName = contract.contractDetails?.crewDetails?.name?.toLowerCase() || "";
        const agentName = contract.contractDetails?.crewingAgent?.agentName?.toLowerCase() || "";
        return (
            vesselName.includes(searchQuery.toLowerCase()) ||
            crewName.includes(searchQuery.toLowerCase()) ||
            agentName.includes(searchQuery.toLowerCase())
        );
    });

    return (
        <>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Box
                    sx={{
                        p: 1,
                        bgcolor: "#C30B12",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                    }}
                >
                    {/* Search Bar aligned to the left */}
                    <TextField
                        placeholder="Search by vessel, crew, or agent name..."
                        variant="outlined"
                        size="small"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="primary" />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            bgcolor: "#f5f5f5",
                            borderRadius: 2,
                            width: "300px",
                        }}
                    />

                    {/* Centered Title */}
                    <Typography
                        variant="h6"
                        component="h2"
                        fontWeight="500"
                        sx={{
                            color: "white",
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)", // Centers the text
                            whiteSpace: "nowrap",
                        }}
                    >
                        Vessel sign on
                    </Typography>
                </Box>


                {/* Table Displaying Contract Details */}
                {Array.isArray(signonDetails) && signonDetails.length > 0 ? (
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Sr. No.</TableCell>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Contract Details</TableCell>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Documents</TableCell>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredContracts.length > 0 ? (
                                filteredContracts.map((contract, index) => {
                                    const cocDate = contract.contractStatusAfterForm1?.coc?.[0]?.Date;
                                    const duration = contract.contractDetails?.contractDuration;
                                    const contractRemainingLabel = getContractRemainingDays(cocDate, duration);

                                    return (
                                        <TableRow key={index}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                {/* {console.log(contract)} */}
                                                <Box display="flex" flexDirection="row" gap={4} mb={1}>
                                                    <Typography variant="subtitle2" fontWeight="bold">
                                                        <strong style={{ color: "black" }}>Vessel Name: {contract.contractDetails?.ShipDetails?.vesselname || "N/A"}</strong>
                                                    </Typography>
                                                    {contract.contractDetails?.transferedAfterSignOnVesselName && (
                                                        <Typography variant="subtitle2" fontWeight="bold">
                                                            <strong style={{ color: "black" }}>Transferred Vessel Name:</strong>{" "}
                                                            {contract.contractDetails.transferedAfterSignOnVesselName}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                                    <Chip
                                                        size="small"
                                                        label={`Crew: ${contract.contractDetails?.crewdetails?.name || "N/A"}`}
                                                        sx={{ bgcolor: "#e3f2fd", color: "#0d47a1" }}
                                                    />
                                                    <Chip
                                                        size="small"
                                                        label={`Indos No.: ${contract.contractDetails?.crewdetails?.indosno || "N/A"}`}
                                                        sx={{ bgcolor: "#fff9c4", color: "#f57f17" }}
                                                    />
                                                    <Chip
                                                        size="small"
                                                        label={`Agent: ${contract.contractDetails?.crewingAgent?.agentName || "N/A"}`}
                                                        sx={{ bgcolor: "#e8f5e9", color: "#1b5e20" }}
                                                    />
                                                    <Chip
                                                        size="small"
                                                        label={`COC Date: ${contract.contractStatusAfterForm1?.coc?.[0]?.Date
                                                            ? new Date(contract.contractStatusAfterForm1.coc[0].Date).toLocaleDateString("en-GB", {
                                                                day: "2-digit",
                                                                month: "2-digit",
                                                                year: "numeric",
                                                            })
                                                            : "N/A"
                                                            }`}
                                                        sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                                                    />

                                                    <Chip
                                                        size="small"
                                                        label={`SignOn Date: ${contract.contractStatusAfterForm1?.signOn?.[0]?.date
                                                            ? new Date(contract.contractStatusAfterForm1.signOn[0].date).toLocaleDateString("en-GB", {
                                                                day: "2-digit",
                                                                month: "2-digit",
                                                                year: "numeric",
                                                            })
                                                            : "N/A"
                                                            }`}
                                                        sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                                                    />

                                                    {contractRemainingLabel && (
                                                        <Chip
                                                            size="medium"
                                                            icon={
                                                                contractRemainingLabel === "Contract Ended" ? (
                                                                    <WarningIcon sx={{ color: "#b71c1c" }} />
                                                                ) : (
                                                                    <HourglassEmptyIcon sx={{ color: "#0277bd" }} />
                                                                )
                                                            }
                                                            label={contractRemainingLabel}
                                                            sx={{
                                                                bgcolor: contractRemainingLabel === "Contract Ended" ? "#ffebee" : "#e1f5fe",
                                                                color: contractRemainingLabel === "Contract Ended" ? "#b71c1c" : "#01579b",
                                                                fontWeight: "bold",
                                                                borderRadius: 2,
                                                                px: 2,
                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                                                userSelect: "none",
                                                                minWidth: 180,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 1,
                                                            }}
                                                        />
                                                    )}

                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                {/* Check if any signOn file exists */}
                                                {contract.contractStatusAfterForm1?.signOn?.[0] && (
                                                    <>
                                                        {(contract.contractStatusAfterForm1.signOn[0].cdcStamppageFile?.filePath ||
                                                            contract.contractStatusAfterForm1.signOn[0].ImoCrewListFile?.filePath) && (
                                                                <IconButton
                                                                    onClick={() => handleOpenSignOnFiles(contract.contractStatusAfterForm1.signOn[0])}
                                                                >
                                                                    <PictureAsPdfIcon sx={{ color: "red" }} />
                                                                </IconButton>
                                                            )}
                                                    </>
                                                )}
                                            </TableCell>

                                            <TableCell>
                                                <IconButton variant="contained" color="primary" onClick={() => handleOpen(contract, contract.contractDetails?.crewdetails?.name || "N/A")}>
                                                    <EditIcon />
                                                </IconButton>

                                                <Tooltip title="Transfer Vessel">
                                                    <IconButton
                                                        onClick={() => handleTransfer(contract.contractDetails?._id)}
                                                        color="secondary"
                                                    >
                                                        <SwapHorizIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={2}>
                                        <Typography variant="h6" align="center">No Matching Results</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                ) : (
                    <Typography variant="h6" gutterBottom>No Sign-On Details Found</Typography>
                )}
            </Paper>

            <TransferVesselModal
                open={contractopenModal}
                onClose={() => setContractopenModal(false)}
                contractId={selectedContractId}
            />
            {/* Modal to Enter Sign-On Details */}
            <Modal open={open} onClose={handleClose}>
                <Paper
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        p: 3,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Enter Sign-Off: {" "}
                        {selectedCrewName && (
                            <span style={{ color: "green" }}> {selectedCrewName}</span>
                        )}
                    </Typography>
                    <TextField
                        fullWidth
                        required
                        label="Port Name"
                        name="portName"
                        value={formData.portName}
                        onChange={handleChange}
                        margin="dense"

                    />
                    <TextField
                        fullWidth
                        required
                        label="Port Country"
                        name="portCountry"
                        value={formData.portCountry}
                        onChange={handleChange}
                        margin="dense"

                    />
                    <TextField
                        fullWidth
                        required
                        label="Date"
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        inputProps={{
                            max: new Date().toISOString().split("T")[0],
                        }}

                    />

                    {/* File Upload: cdc Stamp page File Page */}
                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Typography variant="body2" gutterBottom>
                            CDC
                        </Typography>
                        <label htmlFor="cdc-upload">
                            <input
                                accept="application/pdf,image/*"
                                style={{ display: "none" }}
                                id="cdc-upload"
                                type="file"
                                name="cdcStamppageFile"
                                onChange={handleFileChange}
                            />
                            <Button
                                variant="outlined"
                                component="span"
                                fullWidth
                            >
                                {formData.cdcStamppageFile?.originalName || "Upload File"}
                            </Button>
                        </label>
                    </Box>

                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Typography variant="body2" gutterBottom>
                            Passport
                        </Typography>
                        <label htmlFor="passport-upload">
                            <input
                                accept="application/pdf,image/*"
                                style={{ display: "none" }}
                                id="passport-upload"
                                type="file"
                                name="passport"
                                onChange={handleFileChange}
                            />
                            <Button
                                variant="outlined"
                                component="span"
                                fullWidth
                            >
                                {formData.passport?.originalName || "Upload File"}
                            </Button>
                        </label>
                    </Box>

                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Typography variant="body2" gutterBottom>
                            salary closure
                        </Typography>
                        <label htmlFor="salaryclose-upload">
                            <input
                                accept="application/pdf,image/*"
                                style={{ display: "none" }}
                                id="salaryclose-upload"
                                type="file"
                                name="salaryclose"
                                onChange={handleFileChange}
                            />
                            <Button
                                variant="outlined"
                                component="span"
                                fullWidth
                            >
                                {formData.salaryclose?.originalName || "Upload File"}
                            </Button>
                        </label>
                    </Box>

                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Button onClick={handleClose} variant="outlined">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSave}
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            startIcon={loading && <CircularProgress size={20} color="inherit" />}
                        >
                            {loading ? "Saving..." : "Save"}
                        </Button>
                    </Box>
                </Paper>
            </Modal>

            {/* Modal for documents Details */}
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "60%", md: "50%" },
                        maxHeight: "80vh",
                        bgcolor: "white",
                        boxShadow: 24,
                        p: 3,
                        borderRadius: 2,
                        overflowY: "auto",
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
                    >
                        Sign-On Documents
                    </Typography>

                    {selectedDocuments.length > 0 ? (
                        selectedDocuments.map((doc, index) => (
                            <Paper
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    p: 2,
                                    mb: 2,
                                    boxShadow: 2,
                                    borderRadius: 2,
                                    transition: "0.3s",
                                    "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                                }}
                            >
                                <Box display="flex" alignItems="center">
                                    <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                                    <Typography variant="body1">
                                        {doc.name || "Unnamed Document"}
                                    </Typography>
                                </Box>

                                {doc.filePath && doc.filePath.trim() !== "" ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                        sx={{ textTransform: "none" }}
                                    >
                                        Download
                                    </Button>
                                ) : (
                                    <Typography variant="body2" color="textSecondary">
                                        No File Available
                                    </Typography>
                                )}
                            </Paper>
                        ))
                    ) : (
                        <Typography align="center" color="textSecondary">
                            No documents available
                        </Typography>
                    )}

                    <Box display="flex" justifyContent="center" mt={2}>
                        <Button variant="contained" color="error" onClick={() => setOpenModal(false)}>
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>


            <ToastContainer />
        </>
    );
};

export default SignOnModal;
